import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { AboutTabs, AboutUsViewModel } from 'src/app/view-models/about-us.viewmodel';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent extends BaseComponent<AboutUsViewModel> implements OnInit {
  // tabLocation: number = AboutTabs.tab1;


  constructor(commonService: CommonService, logService: LogHandlerService) {
    super(commonService, logService);
    this.viewModel=new AboutUsViewModel();
  }

  ngOnInit(): void {

  }

  updateTabLocation(tabLocation: AboutTabs) {
    switch (tabLocation) {
      case AboutTabs.tab3:

        break;
      case AboutTabs.tab2:

        break;
      case AboutTabs.tab1:
      default:

        break;
    }
    this.viewModel.tabLocation = tabLocation;
  }




}


